import { colors } from '../../../../theme/colors';
import {
  borderRadius,
  color,
  display,
  flexbox,
  styled,
  textAlign,
  width,
} from "@mui/system";
import {
  Avatar,
  Typography,
  Box,
  TextField,
  Button,
  Paper,
  FormControl,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";

export const FormContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  borderRadius: theme.shape.borderRadius,
  fontFamily:
    '"Public Sans Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  "& .UploadImage": {
    width: "140px",
    height: "140px",
    borderRadius: "50%",
    color: "#919EAB",
    position: "relative",
    marginTop: "50px",
    marginBottom: "30px",
    cursor: "pointer",
  },
  "& .upload-placeholder": {
    position: "absolute",
    backgroundColor: colors.primary,
    boxShadow: `${colors.primary} 0px 3px 15px -3px`,
    borderRadius: "50%",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  "& .upload-placeholder_hover": {
    "&:hover": {
      opacity: 0.7,
    },
  },
  "& .file_format": {
    color: "#919EAB",
    fontSize: "0.75rem",
  },
  "& .upload-input": {
    display: "none",
  },
  "& .profile_avtar": {
    width: "100%",
    height: "100%",
  },
  "& .opacity-0": {
    opacity: 0,
  },
  "& .opacity-1": {
    opacity: 1,
    backgroundColor: "rgb(0 0 0 / 50%) !important",
    color: "#fff",
  },
  "& .submit_btn": {
    textTransform: "capitalize",
    borderRadius: "10px",
    backgroundColor: colors.primary,
    marginTop: "0",
    marginBottom: "20px",
    color: "#fff",
    textAlign: "center",
    minWidth: "180px",
    padding: "10px 24px",
    fontSize: "0.9rem",
    fontWeight: 600,
    letterSpacing: "0.3px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      boxShadow: `0 6px 20px ${colors.primary}44`,
      transform: "translateY(-1px)",
    },
  },
  "& .download-icon": {
    marginRight: "5px",
  },
  "& .css-1e6y48t-MuiButtonBase-root-MuiButton-root:hover": {
    backgroundColor: `${colors.primary} !important`,
  },
}));

export const SectionHeader = styled(Typography)(({ theme }) => ({
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#919EAB",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));

export const UploadBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  fontSize: "0.75rem",
  "& .css-r40f8v-MuiTypography-root": {
    fontSize: "inherit",
  },
}));
export const ToggleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  padding: theme.spacing(2),
  "& .css-1f2kvjf-MuiFormControlLabel-root .MuiFormControlLabel-label": {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
  },
  "& .css-byenzh-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked": {
    color: "green",
  },
  "& .css-byenzh-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track":
    {
      backgroundColor: "green",
    },
}));

// Styled text for the switch label
export const LabelText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "0.875rem",
  lineHeight: 1.57143,
}));

// Styled caption text
export const CaptionText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: "#637381",
  marginTop: theme.spacing(1),
}));

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 120,
  height: 120,
  marginBottom: theme.spacing(2),
  "& .css-i4bv87-MuiSvgIcon-root": {
    color: "#919EAB",
  },
}));

export const FileInput = styled("input")({
  display: "none",
});

export const CaptionTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const CustomPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: "center",
  backgroundColor: "#fff",
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
  borderRadius: "15px",
}));

export const UploadFileWrapper = styled(Box)({
  borderRadius: "15px",
  padding: 10,
  cursor: "pointer",
  margin: "auto",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  backgroundColor: colors.primary,
  boxShadow: `${colors.primary} 0px 3px 15px -3px`,
});

export const RightSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "#fff",
  fontFamily: "inherit",
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
  borderRadius: "15px",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "rgba(145, 158, 171, 0.5)",
      borderRadius: "10px",
      transition: "border-color 0.2s ease",
    },
    "&:hover fieldset": {
      borderColor: "rgba(145, 158, 171, 0.85)",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      borderWidth: "2px",
    },
  },
  "& .css-1e3u5so-MuiFormControl-root-MuiTextField-root": {
    marginTop: "0",
    marginBottom: "0",
  },
  "& .css-18c6uwj-MuiFormControl-root-MuiTextField-root": {
    marginTop: "0",
  },
  "& .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root.Mui-focused": {
    color: `${colors.primary} !important`,
    fontWeight: 600,
  },
  "& .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root": {
    color: `${colors.primary} !important`,
    fontWeight: 600,
  },
  "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
    color: "#919EAB !important",
  },
  "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderColor: colors.primary,
    },
  "& .css-z3c6am-MuiFormControl-root-MuiTextField-root": {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(145, 158, 171,0.7)",
        borderRadius: "10px",
      },
      "&.Mui-focused fieldset": {
        borderColor: colors.primary,
      },
    },
  },
  "& .react-datepicker-wrapper": {
    width: "100%",
    display: "block",
  },
  "& .react-datepicker__input-container": {
    width: "100%",
    display: "block",
  },
  "& .react-datepicker__input-container > input": {
    borderRadius: "10px",
    border: "1px solid rgba(145, 158, 171, 0.5)",
    width: "100%",
    padding: "20px 13px",
    boxSizing: "border-box",
    fontSize: "0.95rem",
    color: "#111111",
    transition: "border-color 0.2s ease",
    outline: "none",
    "&:hover": {
      borderColor: "rgba(145, 158, 171, 0.85)",
    },
    "&:focus": {
      border: `2px solid ${colors.primary}`,
    },
    "::placeholder": {
      color: "#919EAB",
      fontSize: "15px",
    },
  },
  "& .react-datepicker__header": {
    // backgroundColor: "#37699bd6",
  },
}));

export const CustomFormControl = styled(FormControl)(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(2),
  "& .MuiInputBase-root": {
    borderRadius: theme.shape.borderRadius,
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
}));

export const CustomPhoneInput = styled(PhoneInput)(({ theme }) => ({
  border: `1px solid ${colors.primary}`,
  ":hover": {
    border: `1px solid ${colors.primary}`,
  },
  borderRadius: "10px",
  "& .flag-dropdown": {
    borderRadius: "10px 0 0 10px",
    borderTop: "none",
    borderBottom: "none",
    border: "none",
  },
  "& .selected-flag:hover": {
    backgroundColor: "unset !important",
  },
  "& .open": {
    backgroundColor: "unset !important",
  },
  "& .form-control": {
    height: "55px",
    borderRadius: "10px",
    border: "none",
  },
}));
